<template>
  <div>
    <NavBar/>
    <v-main class="third-bg">
      <div id="HomePage" class="row ">
        <div class="col-12 p-0 position-relative">
          <div
              v-if="banner !== null && banner !== undefined && banner.length > 0"
              class="row "
              dir="ltr">
            <carousel
                :autoplay="true"
                :dots="false"
                :items="1"
                :loop="false"
                :margin="5"
                :nav="false"
                :rtl="true"
                class="col-12 py-0 ">
              <div
                  v-for="item in banner"
                  :key="item.BannerId">
                <v-img
                    v-if="item.FileUrl !== null"
                    :src="$replaceHttps(item.FileUrl)"
                    @click="$openLink(item.Link)">
                </v-img>
              </div>
            </carousel>
          </div>
          <div id="navBar" class="col-auto secondary-bg position-absolute left-nav-card d-none d-md-block"
               style="width:180px ">
            <div class="row text-center">
              <router-link :to="{path:'Services' , query:{id : 11}}"
                           class="px-3 col-12  left-nav-link">
                اعضای باشگاه ایران زیلو
              </router-link>
              <router-link v-for="(item,i) in leftNav"
                           :key="i"
                           :to="item.path"
                           class="px-3 col-12  left-nav-link">
                {{ item.text }}
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid third-bg">
        <div class="row">
          <div class="container position-relative mt-5 align-self-center">
            <div class="row align-self-center">
              <div class="col-12 text-center">
                <h1 class="primary-text">آموزش املاک، آموزش مشاورین املاک و صدور مدرک مشاورین املاک</h1>
                <h2 class="primary-text font-14 mt-5 px-4">آکادمی کاشانی کیا با بیش از 30 سال سابقه در زمینه آموزش املاک،آموزش مشاوران املاک،آموزش مشاوران املاک با مدرک معتبر،فروش سایت تخصصی و اتوماسیون اداری املاک در خدمت شما عزیزان میباشد</h2>
              </div>
              <div class="col-md-3 col-6">
                <div class="icon-bg mx-auto">
                  <i class="fa-solid fa-user-graduate icon"></i>
                </div>
                <div class="h-service text-center pt-5"> حق امتیاز</div>
              </div>
              <div class="col-md-3 col-6">
                <div class="icon-bg mx-auto">
                  <i class="fa-solid fa-address-card icon"></i>
                </div>
                <div class="h-service text-center pt-5">ارایه مدارک بین المللی</div>
              </div>
              <div class="col-md-3 col-6">
                <div class="icon-bg mx-auto">
                  <i class="fa-solid fa-signal icon"></i>
                </div>
                <div class="h-service text-center pt-5">ساخت و افزایش بهره وری آژانس</div>
              </div>
              <div class="col-md-3 col-6">
                <div class="icon-bg mx-auto">
                  <i class="fa-solid fa-handshake icon "></i>
                </div>
                <div class="h-service text-center pt-5"> دریافت نمایندگی</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid bg-white py-10">
        <div class="container-md ">
          <div class="row mt-10">
            <div class="col-auto mx-auto  font-16">
              <div class="border-bottom-gold pb-2 px-5 font-18">
                دسته بندی محصولات
              </div>
            </div>
            <div class="col text-left">
              <v-btn color="primary" outlined :to="{path:'ProductCategories'}">
                مشاهده بیشتر
              </v-btn>
            </div>
            <div
                v-if="courses !== null && courses !== undefined && courses.length > 0"
                class="col-12 "
                dir="ltr">
              <carousel
                  :autoplay="true"
                  :dots="false"
                  :items="4"
                  :loop="false"
                  :margin="15"
                  :nav="false"
                  :responsive="{0:{items:1,nav:false},600:{items:2,nav:false}
                      ,900:{items:3,nav:false},1200:{items:4,nav:false}}"
                  :rtl="true"
                  class="py-0 ">
                <div v-for="item in courses" :key="item.ProductCategoryId" dir="rtl">
                  <ShoppingCategoryCard :item="item"/>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
      <!--    <div class="container-fluid secondary-bg py-5 my-15">
            <div class="row">
              <div class="col-auto mx-auto text-center">
                <div class="font-16 primary-text">
                  اطلاع از تخفیف های ویژه مشاورین املاک فقط مخصوص باشگاه مشتریان
                </div>
                <v-btn class="mt-6" color="third" outlined>
                  <span class="primary-text">
                       عضویت در باشگاه مشتریان
                  </span>

                </v-btn>
              </div>
            </div>
          </div>-->
      <!--
      <div class="container-fluid bg-white pb-10">
        <div class="container ">
          <div class="row ">
            <div class="col-auto mx-auto  font-16">
              <div class="border-bottom-gold pb-2 px-5 font-18">
                محصولات فیزیکی
              </div>
            </div>
            <div class="col text-left">
              <v-btn :to="{path:'allProducts',query:{type:'1'}}" color="primary" outlined>
                مشاهده بیشتر
              </v-btn>
            </div>
            <div
                v-if="physicalProducts !== null && physicalProducts !== undefined && physicalProducts.length > 0"
                class="col-12 "
                dir="ltr">
              <carousel
                  :autoplay="true"
                  :dots="false"
                  :items="4"
                  :loop="false"
                  :margin="15"
                  :nav="false"
                  :responsive="{0:{items:1,nav:false},750:{items:2,nav:false}
                      ,1200:{items:3,nav:false}}"
                  :rtl="true"
                  class="py-0 ">
                <div v-for="item in physicalProducts" :key="item.ProductId" dir="rtl">
                  <ProductsCard :item="item"/>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>-->
      <div class="container-fluid secondary-bg  py-8">
        <div class="row">
          <div class="col-auto mx-auto text-center">
            <div class="font-16 primary-text">
              مشاوره برای ساخت آژانس املاک بر اساس مدل SMART
            </div>
            <v-btn class="mt-6" color="third" outlined :to="{path:'Services' , query:{id : 6}}">
            <span class="primary-text">
ساخت آژانس املاک            </span>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="container-fluid bg-white py-10">
        <div class="container ">
          <div class="row ">
            <div class="col-auto mx-auto  font-16">
              <div class="border-bottom-gold pb-2 px-5 font-18">
                محصولات
              </div>
            </div>
            <div class="col text-left">
              <v-btn :to="{path:'allProducts'}" color="primary" outlined>
                مشاهده بیشتر
              </v-btn>
            </div>
            <div
                v-if="digitalProducts !== null && digitalProducts !== undefined && digitalProducts.length > 0"
                class="col-12 "
                dir="ltr">
              <carousel
                  :autoplay="true"
                  :dots="false"
                  :items="4"
                  :loop="false"
                  :margin="15"
                  :nav="false"
                  :responsive="{0:{items:1,nav:false},750:{items:2,nav:false}
                      ,1200:{items:3,nav:false}}"
                  :rtl="true"
                  class="py-0 " dir="rtl">
                <div v-for="item in digitalProducts" :key="item.ProductId">
                  <ProductsCard :item="item"/>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid third-bg pt-10">
        <div class="container">
          <div class="row ">
            <div class="col-auto mx-auto  font-16">
              <div class="border-bottom-gold pb-2 px-5 font-18">
                مقالات
              </div>
            </div>
            <div class="col text-left">
              <v-btn color="primary" outlined to="ArticlesList">
                مشاهده بیشتر
              </v-btn>
            </div>
            <div
                v-if="article !== null && article !== undefined && article.length > 0"
                class="col-12 "
                dir="ltr">
              <carousel
                  :autoplay="true"
                  :dots="false"
                  :items="4"
                  :loop="false"
                  :margin="15"
                  :nav="false"
                  :responsive="{0:{items:1,nav:false},600:{items:2,nav:false}
                      ,900:{items:3,nav:false},1200:{items:4,nav:false}}"
                  class="py-0">
                <div v-for="item in article" :key="item.ArticleId">
                  <router-link :to="{path:'ContentDetail' , query:{id : item.ArticleId , type: 3}}"
                               class="bg-white rounded-lg d-block">
                    <ContentCard :item="item"/>
                  </router-link>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </v-main>

    <FooterComponent/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between secondary-bg">
          <v-btn
              color="primary"
              icon
              @click="showResultDialog = false">
            <i class="fas fa-times ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

import ShoppingCategoryCard from "@/Academy/components/ShoppingCategoryCard";
import ProductsCard from "@/Academy/components/ProductsCard";
import ContentCard from "@/Academy/components/ContentCard";
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "HomePage",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {FooterComponent, NavBar, ContentCard, ProductsCard, ShoppingCategoryCard, carousel},

  data: () => ({
    showLoaderDialog: false,
    showResultDialog: false,
    dialogResult: null,
    banner: [],
    leftNav: [
      {
        text: "تماس با ما",
        path: "/ConnectUs"
      },
      {
        text: "درباره ما",
        path: "/AboutUs"
      },
      {
        text: "قوانین و مقررات",
        path: "/RulesOfRegulation"
      },
      {
        text: "ثبت نظر/ شکایت",
        path: "/CommentsAndComplaints"
      },
      {
        text: "رویداد",
        path: "/EventsList"
      },
      {
        text: "اخبار",
        path: "/NewsesList"
      },
      {
        text: "مقالات",
        path: "/ArticlesList"
      },

    ],
    courses: [],
    physicalProducts: [],
    digitalProducts: [],
    article: [],
  }),
  mounted() {
    this.getBanner();

    let _iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/)
    if (_iOSDevice) {
      this.$addToHomescreen.mount({
        lang: "en_GB",
        buttonColor: "#F6B11E",
        title: 'وب اپلیکیشن آموزش املاک کاشانی کیا',
        iconPath: 'https://pwa.amoozeshamlak.com/img/icons/favicon.ico',
        content: 'وب اپلیکیشن آموزش املاک کاشانی کیا را به صفحه اصلی موبایل خود اضافه کنید'
      });
    }

  },
  methods: {
    getBanner() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetBanners", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.banner = JSON.parse(result)
            this.showLoaderDialog = false
            this.getData()
          })
          .catch(error => console.log('error', error));
    },
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetHomeData", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.courses = json.productCategories
            //this.physicalProducts = json.products.filter(x => x.TypeProduct === 1)
            this.digitalProducts = json.products;
            this.article = json.articles
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    }


  }
}

</script>

<style scoped>


</style>
